// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "babel-polyfill";
import config from "./config/config.js";
import commonFunc from "./api/common/common.js";
import requestService from "./api/common/request.js";
import interfaceApi from "./api/common/interface.js";
import ruleApi from "./api/rules/rule.js";
import dataDicObj from "./api/common/dataDictionary.js";
import valueSetObj from "./api/common/valueSetObj.js";
import i18n from "@/api/i18n";
// vuex 应用程序开发的状态管理模式
import store from "./store";

import "./assets/styles/style.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "simple-line-icons/css/simple-line-icons.css";

import PageHeader from "./components/common/PageHeader";
import OprateDetail from "./components/OprateDetail";
import OprateUpload from "./components/OprateUpload";
import LapUploadFile from "./components/common/LapUploadFile";
import LapPagination from "./components/common/LapPagination";
import LapSearchBtn from "./components/common/LapSearchBtn";
import LapExportBtn from "./components/common/LapExportBtn";
import LapChangeLang from "./components/common/LapChangeLang";
import LapDownloadBtn from "./components/common/LapDownloadBtn";
Vue.component("page-header", PageHeader);
Vue.component("OprateDetail", OprateDetail);
Vue.component("OprateUpload", OprateUpload);
Vue.component("lap-upload-file", LapUploadFile);
Vue.component("lap-pagination", LapPagination);
Vue.component("lap-search-btn", LapSearchBtn);
Vue.component("lap-export-btn", LapExportBtn);
Vue.component("lap-change-lang", LapChangeLang);
Vue.component("lap-download-btn", LapDownloadBtn);
Vue.use(ElementUI);

//使用自定义JS库
Vue.prototype.$commonFunc = commonFunc;
Vue.prototype.$config = config;
Vue.prototype.$requestService = requestService;
Vue.prototype.$interfaceApi = interfaceApi;
Vue.prototype.$ruleApi = ruleApi;
Vue.prototype.$dataDicObj = dataDicObj;
Vue.prototype.$valueSetObj = valueSetObj;

Vue.prototype.$inputLengthObj = {
    maxLength1: 40,
    maxLength2: 18,
    maxLength3: 100,
    maxLength4: 255,
    maxLength5: 1000,
    maxLength6: 4,
    maxLength7: 20
};

Vue.config.productionTip = false;

new Vue({
    el: "#app",
    router,
    store, // 使用store
    i18n,
    components: { App },
    template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js